import { FunctionComponent, useContext } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import LineItemContext from "components/job/LineItem/LineItemContext";
import { SKELETONS } from "components/job/LineItem/constants";

const Title: FunctionComponent = () => {
  const { title, classNames } = useContext(LineItemContext);
  return (
    <Text
      className={classNames?.title}
      text={title}
      skeletonProps={SKELETONS.title}
    />
  );
};

export default Title;
